import { Button } from 'reactstrap';
import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
}

const PreviousPageButton = (props: Props): JSX.Element => {
  const { intl, handleClick } = props;

  return (
    <Button className="button" color="secondary" onClick={handleClick}>
      {intl.formatMessage({ id: 'goBack' })}
    </Button>
  );
};

export default PreviousPageButton;
